<script lang="ts" setup>
defineOptions({
    name: 'FieldSelect'
});

const model = defineModel<any>();
const props = withDefaults(defineProps<{
    label: string;
    options: Option<any>[];
    invalidFeedback?: (value: any) => string;
    required?: boolean;
    disabled?: boolean;
    description?: string;
    name?: string;
}>(), {
    invalidFeedback: null,
    required: false,
    disabled: false,
    description: null,
    name: undefined
});

const { $t } = useLocalization();
const instance = getCurrentInstance();
const uid = computed(() => `form-field-${instance.uid}`);
const options = computed(() => props.options.map(p => ({ value: p.value, text: $t(p.text) })));
const invalid = computed(() => props.invalidFeedback && props.invalidFeedback(model.value));
</script>

<template>
    <IdeoFormGroup :label="props.label" :required="props.required" :state="!invalid">
        <IdeoFormSelect :id="uid" v-model="model" :name="name" :options="options" :disabled="props.disabled" />
        <small v-if="invalid" class="form-text text-danger d-block">
            {{ $t(invalidFeedback(modelValue)) }}
        </small>
        <template v-if="props.description" #description>
            {{ props.description }}
        </template>
    </IdeoFormGroup>
</template>
